const texts = {
    retirer: value => `Retirer ${value}`,
}

export default texts
